import './testimonial.scss';

import * as gzTestimonialDirective from './testimonial.directive';
import angularTranslate from 'angular-translate';

export default angular.module('gazelle.components.testimonial', [
  angularTranslate
])
  .directive(gzTestimonialDirective.name, gzTestimonialDirective.default)
  .name;



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/carousel/testimonial/testimonial.module.js